import { Autocomplete, TextField } from '@mui/material';
import type { ThemeChoice } from '../hooks/useThemeMode';

const CHOICES: { value: ThemeChoice; label: string }[] = [
  { value: 'system', label: 'Match the system' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'night', label: 'Dark at night (20:00–06:00)' },
];

export default function AppearanceField({ value, onChange }: {
  value: ThemeChoice | undefined;
  onChange: (v: ThemeChoice) => void;
}) {
  const current = CHOICES.find((c) => c.value === value) ?? CHOICES[0];
  return (
    <Autocomplete
      size="small"
      fullWidth
      disableClearable
      options={CHOICES}
      value={current}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      getOptionLabel={(o) => o.label}
      onChange={(_, o) => onChange(o?.value ?? 'system')}
      renderInput={(params) => <TextField {...params} label="Appearance" />}
      sx={{ maxWidth: 272 }}
    />
  );
}
